import { useLocaleContext } from '../../i18n';
import BaseSlider from './BaseSlider';
import { calculateGelsPerHour } from '../../utils/absorptionCalculations';

interface Props {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  zoneColor?: string;
}

export default function MaxAbsorptionSlider({ value, onChange, disabled, zoneColor }: Props) {
  const { locale } = useLocaleContext();

  return (
    <BaseSlider
      label={locale.settings.cyclist.maxAbsorption}
      value={value}
      onChange={onChange}
      min={30}
      max={120}
      step={1}
      unit="g/h"
      disabled={disabled}
      zoneColor={zoneColor}
      secondary={locale.settings.cyclist.gelsPerHourHint.replace('{count}', String(calculateGelsPerHour(value)))}
    >
      {value > 60 && (
        <div className="text-warning text-small mt-2">
          ⚠ {locale.planner.proModeWarning}
        </div>
      )}
    </BaseSlider>
  );
}
